import React, { useState } from "react";
import { clientsCampaignsApi } from "../../api/organizerClientsApi";
import { store } from "../../redux/store/store";
import CampanaCard from "./CampanaCard";
import CampanasResumen from "./CampanasResumen";
import { TIPOS } from "./campanas";
import useCarga from "./useCarga";

/* Clientes > Campañas: the two automatic campaigns (birthday, win-back) and the monthly send summary. */

const CampanasSeccion = () => {
  const local = store.getState?.()?.auth?.negocio?.nombre || "";
  const [resumenKey, setResumenKey] = useState(0);
  const { loading, error, data, reload } = useCarga(() => clientsCampaignsApi(), "campanas", {
    valida: (i) => Array.isArray(i.campaigns),
    mensaje: "No pudimos cargar las campañas.",
  });
  const campanas = TIPOS.map((t) => (data?.campaigns || []).find((c) => c.type === t)).filter(Boolean);

  return (
    <div className="fc-campanas">
      <div className="zr-subhead">
        <h2 className="zr-subhead__title">Campañas</h2>
        <p className="zr-subhead__hint">Mensajes automáticos para tus clientes: un saludo de cumpleaños y una invitación a volver.</p>
      </div>
      {loading && !data && <p className="fc-hint" role="status">Cargando campañas…</p>}
      {error && !data && (
        <div className="fc-error" role="alert">
          {error.status === 403 ? "No tenés permiso para ver campañas." : error.message}{" "}
          <button type="button" className="zr-btn zr-btn--soft" onClick={reload}>Reintentar</button>
        </div>
      )}
      {data && campanas.length === 0 && <div className="fc-empty"><p>Todavía no hay campañas disponibles.</p></div>}
      {campanas.map((c) => (
        <CampanaCard key={c.type} campana={c} local={local} onGuardada={() => setResumenKey((n) => n + 1)} />
      ))}
      {data && <CampanasResumen refreshKey={resumenKey} />}
    </div>
  );
};

export default CampanasSeccion;
